import { FRESH_CHAT_TOKEN } from 'config/vars'
import {
  HIDDEN_FRESHCHAT_PATH_NAMES,
  HIDDEN_FRESHCHAT_ROOT_IDS
} from './constants'
import type { UserState } from 'utils/hooks/use-userInfo'

export const hideFreshChat = () => {
  if (window.fcWidget) {
    window.fcWidget.hide()
  }
}

export const showFreshChat = (rootId: number) => {
  if (window.fcWidget && !HIDDEN_FRESHCHAT_ROOT_IDS.includes(rootId)) {
    window.fcWidget.show()
  }
}

export const hideFreshChatForRootId = (rootId: number) => {
  return HIDDEN_FRESHCHAT_ROOT_IDS.includes(rootId)
}

export const hideFreshChatForPathName = (pathName: string) => {
  if (HIDDEN_FRESHCHAT_PATH_NAMES.includes(pathName)) {
    hideFreshChat()
  }
}

export const initFreshChat = (user: UserState) => {
  if (hideFreshChatForRootId(user?.reader?.root?.id)) {
    return null
  } else {
    const { id, name, email } = user

    const script = document.createElement('script')
    script.src = 'https://wchat.freshchat.com/js/widget.js'
    script.async
    document.body.appendChild(script)

    setTimeout(() => {
      if (window.fcWidget) {
        window.fcWidget.init({
          token: FRESH_CHAT_TOKEN,
          host: 'https://wchat.freshchat.com'
        })
        window.fcWidget.user.setProperties({
          plan: 'Sem plano', // meta property 1
          status: 'Active', // meta property 2
          rootName: user?.reader?.root?.name,
          rootId: user?.reader?.root?.id,
          className: user?.reader?.entity?.name,
          classId: user?.reader?.entity?.id
        })

        try {
          window.fcWidget.setExternalId(id)
          window.fcWidget.user.setFirstName(name)
          window.fcWidget.user.setEmail(email)
          window.fcWidget.user.setProperties({
            status: 'Active' // meta property 2
          })
        } catch (e) {
          console.error('Freshchat: on init error')
        }
      }
    }, 1500)
  }
}
